import { render, staticRenderFns } from "./LmCheckbox.vue?vue&type=template&id=ffe77574&scoped=true&"
import script from "./LmCheckbox.vue?vue&type=script&lang=js&"
export * from "./LmCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./LmCheckbox.vue?vue&type=style&index=0&id=ffe77574&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe77574",
  null
  
)

export default component.exports